import * as React from 'react'
import { useSnapshot } from 'valtio'
import { safeZoneState } from '../../store/safeZoneState.ts'

export const NewSafeZone: React.FC = () => {
    const newSafeZone = (useSnapshot(safeZoneState) as typeof safeZoneState).newSafeZone
    return <>{newSafeZone}</>
}
